import React, { useEffect, useState } from 'react'
import AttendanceHeader from './AttendanceHeader'
import './styles/header.scss'
import AttendeesTable from './AttendeesTable'
import { GetEventAttendeesParams } from 'types/event/eventAttendance'
import { useParams } from 'react-router-dom'
import { useGetEventAttendees } from 'api/Event/Attendance'
import Spinner from 'components/Spinner'
import { eventAttendanceStore } from 'state/event/eventAttendance'

const Attendace = () => {
  const { id }: { id: string } = useParams()
  const { checkInOutModalOpen, importRegistrationsModalOpen } = eventAttendanceStore(store => ({
    checkInOutModalOpen: store.checkInOutModalOpen,
    importRegistrationsModalOpen: store.importRegistrationsModalOpen,
  }))
  const [params, setParams] = useState<GetEventAttendeesParams>({
    page: 1,
    limit: 10,
    eventId: id,
  })
  const {
    data: attendeesData,
    isLoading: attendeesDataLoading,
    isFetching: attendeesDataFetching,
    refetch: attendeesRefetch,
  } = useGetEventAttendees(id, params)

  useEffect(() => {
    if (!checkInOutModalOpen) attendeesRefetch()
  }, [id, params, checkInOutModalOpen])

  useEffect(() => {
    if (!importRegistrationsModalOpen) attendeesRefetch()
  }, [importRegistrationsModalOpen])

  return (
    <div className="attendance-container">
      <AttendanceHeader params={params} setParams={setParams} />

      <div className="table">
        {attendeesDataLoading || attendeesDataFetching ? (
          <div className="flex justify-center py-40px">
            <Spinner />
          </div>
        ) : (
          <AttendeesTable
            data={attendeesData}
            params={params}
            setParams={setParams}
          />
        )}
      </div>
    </div>
  )
}

export default Attendace
